"use client";

import { Suspense, useEffect, useState } from "react";
import dynamic from "next/dynamic";

const Footer = dynamic(() => import("@/components/global/Footer"), { ssr: false });
const CategoryPopup = dynamic(() => import("@/components/global/CategoryPopup"), { ssr: false });
const FloatMenu = dynamic(() => import("@/components/global/FloatMenu"), { ssr: false });
const Load = dynamic(() => import("@/components/global/Load"), { ssr: false });

export default function MainLayoutExtras() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setReady(true), 1200);
    return () => window.clearTimeout(timer);
  }, []);

  if (!ready) return null;

  return (
    <>
      <Footer />
      <CategoryPopup />
      <Suspense fallback={<div></div>}>
        <Load />
      </Suspense>
      <FloatMenu />
    </>
  );
}
